import { Heart } from "lucide-react";
import { Link } from "react-router-dom";
import { api } from "../api.js";
import { Avatar, EmptyState, Loading } from "../components.jsx";
import { useAsync } from "../hooks.js";
import { formatDate, profilePath } from "../utils.js";

export default function NotificationsPanel() {
  const { data, loading, error } = useAsync(async () => {
    const response = await api("/v1/me/notifications");
    await api("/v1/me/notifications/read", { method: "PUT" });
    return response;
  }, []);
  if (loading) return <Loading />;
  if (error) return <EmptyState title="No se han podido cargar" text={error} />;
  const items = data?.notifications || [];
  if (!items.length) return <EmptyState icon={Heart} title="Nada nuevo" text="Los likes a tus reseñas aparecerán aquí." />;
  return <div className="notification-list">{items.map((item) => <article key={item.id}><Avatar user={item.actor} size={42} /><div><p><Link to={profilePath(item.actor.username)}>{item.actor.displayName}</Link> ha dado like a tu reseña de <strong>{item.movie?.title || "una película"}</strong>.</p><time>{formatDate(item.createdAt)}</time></div><Heart className="notification-heart" fill="currentColor" /></article>)}</div>;
}
